export default "__VITE_ASSET__DNcb6dqb__"